<template>
  <div class="publicPadding16">
    <div v-if="infoModal.title" class="title1s" >{{infoModal.title}}</div>
    <div v-else class="title1s" >神奇！武夷山景区</div>
    <div class="publicRow publicCenter title2s">
      <div style="margin-right:6px"> <span class="titleColor">发布日期</span> <span class="title2sColor">{{subData(infoModal.showTime)}}</span> </div>
      <div v-if="infoModal.hits" style="margin-left:6px"> <span class="titleColor">点击</span> <span class="title2sColor">{{infoModal.hits}}次</span>  </div>
      <div v-else style="margin-left:6px"> <span class="titleColor">点击</span> <span class="title2sColor">0次</span>  </div>

    </div>
    <div class="rowInline" style="margin-top:15px"></div>
    <div style="margin-top:24px">
       <img :src="Global + infoModal.url" style="width:100%;height:180px;border-radius: 10px" />
    </div>
    <div style="margin-top:24px" class="new" v-html="infoModal.details">  </div>
    <div style="margin-top:24px;height:105px" class="publicRow">
       <img src="@/assets/image/logo1s.png" style="width:105px;height:105px;margin-left:13.5vw" />
       <div class="publicColumn">
         <div class="font16">长按识别二维码</div>
         <div class="font16">关注武夷山景区 </div>
         <div class="font13">服务热线</div>
         <div class="font17">0599-5135110</div>
       </div>
    </div>
  </div>
</template>

<script>
// import { getAboutInfo } from "@/api/common";
import { getMenuOpenList } from "@/api/publicApi";
import  {addHits}  from "@/util/publicHits";
export default {
  name: 'AppPageTwo',
  props: {
  },
  computed: {
  },
  data() {
    return {
      id:'',
      publicIconUrl: 'http://wysgw.lylcc.com/',
      infoModal:{}
    };
  },
  created(){
  },
  mounted() {
    this.initData()
  },
  methods: {
    subData(str){
      var result = ''
      if(str){
        result = str.substring(0,10)
      }
      return result
    },
    async initData(){
      // const { code, data } = await getAboutInfo();
      const { code, data } = await getMenuOpenList(0,'about_info',1,1);
      if (code == 200) {
        // this.infoModal = data[0]
        this.infoModal = data.records[0]
        try {
          addHits(this.infoModal.id)
        } catch (error) {
          alert('00000')
        }
        // console.log('this.infoModal:',this.infoModal)
      }
    }
  }

}
</script>

<style scoped>
.new>>>img{
  width: 100%;
}
.main {
  max-width: 1920px;
  margin: auto;
}
.linShiWidth{
  width: calc(50vw - 24px);
  height:150px;
  margin-bottom:16px;
}
.title1s{
  text-align:center;
  font-size: 16px;
  font-weight: 600;
  margin-top: 20px;
  color: #071420;
}
.title2s{
  margin-top: 19px;
}
.titleColor{
  color: #8B939A;
}
.title2sColor{
  color: #071420;
}
.rowInline{
  width: calc(100vw - 32px);
  height: 1px;
  border-top: 1px dashed  #8B939A;
}
.font16{
  color: #071420;
  font-size: 16px;
  font-weight: 500;
  margin-left: 21px;
  font-family: SourceHanSansCN-Regular;
}
.font13{
  color: #1EC2AB;
  font-size: 13px;
  font-weight: 600;
  margin-left: 21px;
  font-family: SourceHanSansCN-Regular;
  margin-top: 15px;
}
.font17{
  color: #1EC2AB;
  font-size: 17px;
  font-weight: 600;
  margin-left: 21px;
  font-family: Arial-BoldMT;

}

</style>




// WEBPACK FOOTER //
// src/views/app/appPageOne.vue